/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const AutoTestMaxGlobalSetupTimeSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('AUTO_TEST_MAX_GLOBAL_SETUP_TIME')],
    ['value', /* #__PURE__ */ parsers.maybeNull(parsers.duration)],
]);
export class AutoTestMaxGlobalSetupTimeSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return AutoTestMaxGlobalSetupTimeSettingParser.decode(input).map(res => new AutoTestMaxGlobalSetupTimeSetting(res));
    }
    static unsafeDecode(input) {
        return AutoTestMaxGlobalSetupTimeSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AutoTestMaxGlobalSetupTimeSettingParser.encode(data);
    }
    static schema() {
        return AutoTestMaxGlobalSetupTimeSettingParser.schema();
    }
}
